import { isEmpty } from 'lodash';

const fetch = $store => {
  // Added.by.KWShin.2022.08.17.
  const isPcapOs = $store.state.common.properties.isPcapOs == null ? $store.dispatch('common/properties/isPcapOs') : Promise.resolve();
  // Added.by.KWShin.2022.10.14.
  const isPcapOs2 = $store.state.analysis.statistics.isPcapOs == null ? $store.dispatch('analysis/statistics/isPcapOs') : Promise.resolve();
  const system = isEmpty($store.state.common.system.systems) ? $store.dispatch('common/system/fetchSystems') : Promise.resolve();
  // BEGIN::Modified.by.KWShin.2026.09.10.
  // menu(메뉴접근권한)는 user(username)에 의존하므로 user를 먼저 완료시킨 뒤에 조회한다.
  const user = $store.dispatch('common/user/fetchUser');
  const menu = isEmpty($store.state.common.menu.realtime) ? user.then(() => $store.dispatch('common/menu/fetchMenus')) : Promise.resolve();
  // FINISH::Modified.by.KWShin.2026.09.10.
  const group = isEmpty($store.state.common.group.groups) ? $store.dispatch('common/group/fetchGroups') : Promise.resolve();
  const monitors = isEmpty($store.state.common.monitor.monitors) ? $store.dispatch('common/monitor/fetchMonitors') : Promise.resolve();
  const targets = isEmpty($store.state.common.monitor.targets) ? $store.dispatch('common/monitor/fetchTargets') : Promise.resolve();
  const partialTaskType = isEmpty($store.state.common.properties.partialTaskType) ? $store.dispatch('common/properties/fetchPartialTaskType') : Promise.resolve();
  // Added.by.KWShin.2024.01.12.
  const codesLoadKind = isEmpty($store.state.common.properties.codesLoadKind) ? $store.dispatch('common/properties/fetchCodesLoadKind') : Promise.resolve();
  // Added.by.KWShin.2024.01.14.
  const codesLogonType = isEmpty($store.state.common.properties.codesLogonType) ? $store.dispatch('common/properties/fetchCodesLogonType') : Promise.resolve();
  // Added.by.KWShin.2024.09.02.
  const propCboList = isEmpty($store.state.common.properties.propCboList) ? $store.dispatch('common/properties/fetchPropCboList') : Promise.resolve();
  // common/user 상태는 localStorage에 영구화되어 isEmpty 가드가 통하지 않으므로 가드 없이 매번 호출.
  // (menu보다 먼저 dispatch 되도록 위로 끌어올림. Modified.by.KWShin.2026.09.10.)
  return Promise.all([isPcapOs, isPcapOs2, system, menu, group, monitors, targets, partialTaskType, codesLoadKind, codesLogonType, propCboList, user]);
};

export { fetch };
